import { css } from 'styled-components';
import { themeGet, variant } from 'styled-system';

export const controlSize = variant({
  key: 'controlSizes',
  prop: 'size'
});

export const controlStyle = variant({
  key: 'inputs',
  prop: 'variant'
});

export const errorsStyles = props =>
  props.error &&
  css`
    border-color: ${themeGet('colors.error')};
  `;

export const disabledStyles = css`
  background-color: ${themeGet('colors.iceBlueTwo')};
  color: ${themeGet('colors.disabled')};
  cursor: not-allowed;
  &::placeholder {
    color: ${themeGet('colors.disabled')};
  }
`;
